export default {
  licenses: null,
  isLoading: false,
  isSubmitting: false,
  errors: null,
  validationErrors: null,
};
